import styled, { css } from "styled-components";

/* One row of an editor list (sections, links, catalog items...): same card everywhere */
export const Card = styled.div<{ $dimmed?: boolean }>`
  display: flex;
  gap: 0.75rem;
  align-items: center;
  min-height: 64px;
  padding: 0.75rem 1rem 0.75rem 0.75rem;
  cursor: pointer;
  background-color: var(--color-neutral-dark);
  border: 1px solid transparent;
  border-radius: 12px;
  transition: border-color 0.15s;
  will-change: transform;

  &:hover {
    border-color: var(--color-neutral-base);
  }

  .drag-handle {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 32px;
    color: var(--color-neutral-150);
    cursor: grab;

    svg {
      width: 16px;
      height: 11px;
    }
  }

  .text {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 0.125rem;
    min-width: 0;
  }

  .description {
    overflow: hidden;
    font-family: Inter, sans-serif;
    font-size: 0.75rem;
    line-height: 1rem;
    color: var(--color-neutral-150);
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .title {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    min-width: 0;

    > span:first-child {
      display: -webkit-box;
      overflow: hidden;
      font-family: Inter, sans-serif;
      font-size: 0.875rem;
      font-weight: 700;
      line-height: 1.25rem;
      color: ${props => (props.$dimmed ? "var(--color-neutral-150)" : "var(--color-neutral-white)")};
      word-break: break-word;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }

  .actions {
    display: flex;
    flex-shrink: 0;
    gap: 0.5rem;
    align-items: center;
  }
`;

/* The 40px square before the title: a section's icon, or an item's image/emoji */
export const Tile = styled.span<{ $variant: "icon" | "media"; $dimmed?: boolean }>`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  overflow: hidden;
  border-radius: 10px;

  ${props =>
    props.$variant === "icon"
      ? css`
          background-color: ${props.$dimmed ? "var(--color-neutral-base)" : "var(--color-brand-blue)"};

          svg {
            max-width: 20px;
            max-height: 20px;
          }
        `
      : css`
          font-size: 22px;
          line-height: 1;
          background-color: var(--color-neutral-white);
          opacity: ${props.$dimmed ? 0.45 : 1};

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        `}
`;

/* Row actions (show/hide, remove): solid on the card, colored on hover */
export const ActionButton = styled.button<{ $danger?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  color: var(--color-neutral-white);
  background-color: var(--color-neutral-base);
  border-radius: 100%;
  transition:
    background-color 0.15s,
    color 0.15s;

  &:hover:not(:disabled) {
    background-color: ${props => (props.$danger ? "var(--color-feedback-danger)" : "var(--color-brand-blue)")};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.35;
  }
`;
